<template>
<div class="container">
    <div class="row mb-2 d-flex align-items-center justify-content-center">
        <div class="col-12">
            <Button @click="$router.push(`/user/group/${$route.params.groupId}${$store.state.user.userAdm ? `?route=${$route.query.originalRoute}` : ''}`)" size="small" type="outline" color="grey">
                <ArrowDropdown :rotate="90" /> Voltar
            </Button>
        </div>
        <div class="col-12 mt-3">
            <h3 class="c-ndarkthree bold">
                {{ registeredEmail ? 'Convidar usuário ' : 'Novo usuário' }}
            </h3>
        </div>
        <div class="col-12 mt-4">
            <el-steps direction="vertical" :active="activeStep" finish-status="success">

                <el-step title="Inserir e-mail do usuário">
                    <div class="col-5 mt-4 pt-2 pl-0" slot="description" v-if="activeStep == 0">
                        <el-form :model="userInfo" ref="userEmail" :rules="emailRules" @keyup.native="validateEmailForm" @keydown.native="registredUserInCompany = false" @submit.native.prevent @submit.native="verifyUserEmail" >
                            <el-form-item prop="email">
                                <InputText v-model="userInfo.email" label="E-mail" placeholder="email@dominio.com"/>
                            </el-form-item>
                            <div class="mb-4 mt-5">
                                <Button :color="getPrimaryColor" :disabled="!formEmailValid" @click="verifyUserEmail">Continuar</Button>
                            </div>
                        </el-form>
                    </div>
                </el-step>

                <el-step title="Conferir dados do usuário" v-if="registeredEmail == true && activeStep > 0">
                    <div class="col-6 mt-4 pl-0" slot="description">
                        <div class="row pt-2">
                            <div class="col-12">                                   
                                <InputText v-model="userInfo.name" label="Nome completo " placeholder="Nome do usuário" :readonly="true"/>
                            </div>
                        </div>
                        <div class="row mt-4 mb-4">
                            <div class="col-6">
                                <InputText v-model="userInfo.cpf" label="CPF" placeholder="999.999.999-99" v-mask="'###.***.***-##'" :readonly="true"/>
                            </div>
                            <div class="col-6">
                                <InputText v-model="userInfo.phoneNumber" label="Telefone celular" placeholder="(11) 99999-9999" v-mask="'(##) ****#-####'" :readonly="true"/>
                            </div>
                        </div>
                        <div class="col-12">
                            <h6 class="c-ndarkthree regular mb-3">
                                Nível de acesso
                                <el-tooltip class="item" placement="bottom">
                                    <div slot="content">Os Administradores têm acesso exclusivo a algumas funcionalidades da plataforma,<br />como os níveis de acesso dos usuários e o cadastro das contas bancárias da empresa.</div>
                                    <ExclamationIcon color="#A1A8B8"/>
                                </el-tooltip>
                            </h6>
                            <el-radio v-model="userInfo.accessLevel" :label="1" :class="getPrimaryColor">
                                Operacional
                            </el-radio>
                            <el-radio v-model="userInfo.accessLevel" :label="0" :class="getPrimaryColor">
                                Administrador
                            </el-radio>
                            <h6 class="c-nmidone regular mb-3">
                                Essa pessoa receberá um convite por e-mail para criar uma conta na<br> plataforma com o nível de acesso acima.
                            </h6>
                        </div>
                        <div class="row mt-4 pt-2" v-if="isOrderAntecipationModeOwn">
                            <div class="col-12">
                                <h6 class="c-ndarkthree regular mb-3">
                                    Perfil de acesso
                                </h6>
                                <div class="d-flex mt-4 mb-4">
                                    <el-checkbox :class="getPrimaryColor" v-model="userProfiles.sponsor"><span class="medium">Financiador</span></el-checkbox>
                                    <el-checkbox :class="getPrimaryColor" v-model="userProfiles.buyer"><span class="medium">Comprador</span></el-checkbox>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 mt-4 mb-4">
                                <router-link :class="`${getPrimaryColor} pl-0 c-ndarkfour`" to="" @click.native="activeStep--">Voltar</router-link>
                                <Button :color="getPrimaryColor" class="ml-3" @click="inviteRegistredUser">Finalizar</Button>
                            </div>
                        </div>
                    </div>
                </el-step>

                <el-step title="Inserir dados do usuário" v-if="registeredEmail == false && activeStep > 0">
                    <div class="col-6 mt-4 pl-0" slot="description" v-if="activeStep == 1">
                        <el-form :model="userInfo" ref="userInfo" :rules="userInfosRules">
                            <div class="row pt-2">
                                <div class="col-12">
                                    <el-form-item prop="name">
                                        <InputText v-model="userInfo.name" label="Nome completo " placeholder="Nome do usuário" @keyup.native="validateField('name')" />
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="row mt-3">
                                <div class="col-6">
                                    <el-form-item prop="cpf">
                                        <InputText v-model="userInfo.cpf" label="CPF" placeholder="999.999.999-99" v-mask="'###.###.###-##'" @keyup.native="validateField('cpf')"/>
                                    </el-form-item>
                                </div>
                                <div class="col-6">
                                    <el-form-item prop="phoneNumber">
                                        <InputText v-model="userInfo.phoneNumber" label="Telefone celular" placeholder="(11) 99999-9999" v-mask="'(##) #####-####'"/>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="col-12">
                                <h6 class="c-ndarkthree regular mb-3">
                                    Nível de acesso
                                    <el-tooltip class="item" placement="bottom">
                                        <div slot="content">Os Administradores têm acesso exclusivo a algumas funcionalidades da plataforma,<br />como os níveis de acesso dos usuários e o cadastro das contas bancárias da empresa.</div>
                                        <ExclamationIcon color="#A1A8B8"/>
                                    </el-tooltip>
                                </h6>
                                <el-radio v-model="userInfo.accessLevel" :label="1" :class="getPrimaryColor">
                                    Operacional
                                </el-radio>
                                <el-radio v-model="userInfo.accessLevel" :label="0" :class="getPrimaryColor">
                                    Administrador
                                </el-radio>
                                <h6 class="c-nmidone regular mb-3">
                                    Essa pessoa receberá um convite por e-mail para criar uma conta na<br> plataforma com o nível de acesso acima.
                                </h6>
                            </div>
                            <div class="row">
                                <div class="col-12 mt-4 mb-4">
                                    <router-link :class="`${getPrimaryColor} pl-0 c-ndarkfour`" to="" @click.native="activeStep--">Voltar</router-link>
                                    <Button :disabled="!isButtonEnabled" class="ml-3" @click="inviteUser" :color="getPrimaryColor">
                                        {{ isOrderAntecipationModeOwn ? 'Continuar' : 'Finalizar' }}
                                    </Button>
                                </div>
                            </div>
                        </el-form>
                    </div>
                </el-step>

                <el-step title="Escolher perfil de acesso" v-if="registeredEmail == false && activeStep > 0 && isOrderAntecipationModeOwn">
                    <div class="row mt-4 pl-0" slot="description" v-if="activeStep == 2">
                        <div class="col-12">
                            <h6 class="c-ndarkthree regular mb-3">
                                Perfil de acesso
                            </h6>
                            <div class="d-flex mt-4 mb-4">
                                <el-checkbox :class="getPrimaryColor" v-model="userProfiles.sponsor"><span class="medium">Financiador</span></el-checkbox>
                                <el-checkbox :class="getPrimaryColor" v-model="userProfiles.buyer"><span class="medium">Comprador</span></el-checkbox>
                            </div>
                        </div>
                        <div class="col-12 mt-4">
                            <router-link :class="`${getPrimaryColor} pl-0 c-ndarkfour`" to="" @click.native="activeStep--">Voltar</router-link>
                            <Button :color="getPrimaryColor" class="ml-3" @click="inviteRegistredUser">Finalizar</Button>
                        </div>
                    </div>
                </el-step>

            </el-steps>
        </div>
    </div>
    <FullLoading :color="getPrimaryColorHex.five" v-if="$store.state.user.loading" :text="this.activeStep == 0 ? 'Verificando nossos usuários cadastrados...' : ''"/>
</div>
</template>

<script>
import ArrowDropdown from '@/components/icons/ArrowDropdown'
import FullLoading from '@/components/loading/FullLoading'
import checkUser from '@/api/checkUser'
import insertUserCompany from '@/api/insertUserCompany'
import removeMask from '@/utils/removeMask'
import getEconomicGroupRules from '@/api/getEconomicGroupRules'

export default {
    components: {
        FullLoading,
        ArrowDropdown,
    },
    data() {
        const validateCpf = (_rule, value, message) => {
            if (value && this.registeredCpf == value) message('Este CPF já foi cadastrado.')
            else if (value && value.length !== 14) message('Seu CPF deve ter 11 caracteres')
            else message()
        }
        const validateEmail = (_rule, value, message) => {
            if (this.registredUserInCompany) message('Ops! Este usuário já existe nessa empresa/grupo.')
            else message()
        }
        return {
            activeStep: 0,
            registeredEmail: false,
            registredUserInCompany: false,
            userInfo: {
                id: '',
                groupId: '',
                name: '',
                email: '',
                cpf: '',
                phoneNumber: '',
                userAllowedProfiles: '',
                userCnpjs: {
                    accessLevel: ''
                },
            },
            validFields: {
                name: false,
                cpf: true,
            },
            userProfiles: {
                sponsor: false,
                buyer: false,
            },
            formEmailValid: false,
            formUserValid: false,
            emailRules: {
                email: [
                    {
                        required: true,
                        type: 'email',
                        message: 'Por favor, insira um e-mail válido',
                        trigger: 'change'
                    },
                    {
                        validator: validateEmail,
                        trigger: 'change'
                    },
                ]
            },
            userInfosRules: {
                name: [
                    {
                        required: true,
                        message: 'Por favor, insira o nome',
                        trigger: 'change'
                    },
                ],
                cpf: [
                    {
                        validator: validateCpf,
                        trigger: 'change'
                    },
                ],
                /* phoneNumber: [
                    {
                        required: true,
                        min: 14,
                        message: 'Por favor, insira um telefone celular',
                        trigger: 'change'
                    },
                ], */
            },
            registeredCpf: '',
            isOrderAntecipationModeOwn: false,
        }
    },
    computed: {
        companyType() {
          return 2
        },
        isButtonEnabled() {
            const { name, cpf } = this.validFields
            return (name && cpf) || this.formUserValid
        }
    },
    watch: {
        activeStep(value) {
            if (value == 0) {
                this.userInfo = {
                    id: '',
                    groupId: '',
                    name: '',
                    email: '',
                    cpf: '',
                    phoneNumber: '',
                }
            }
        }
    },
    methods: {
        calculateUserProfile() {
            const { sponsor, buyer } = this.userProfiles
            if (sponsor && buyer) return 'all'
            else if (sponsor && !buyer) return '0'
            else if (!sponsor && buyer) return '2'
            else return ''
        },
        validateEmailForm() {
            this.$refs['userEmail'].validate((valid) => {
                if (valid) {
                    this.formEmailValid = true
                } else {
                    this.formEmailValid = false
                }
            });
        },
        validateUserForm() {
            this.$refs['userInfo'].validate((valid) => {
                if (valid) {
                    this.formUserValid = true
                } else {
                    this.formUserValid = false
                }
            });
        },
        validateField(field) {
            this.$refs['userInfo'].validateField(field, (valid) => {
                if (!valid) {
                    this.validFields[field] = true
                } else {
                    this.validFields[field] = false
                }
            });
        },
        async verifyUserEmail() {
            // Esta linha impede que, ao apertar 'enter', o usuário passe para o próximo passo com um email inválido
            if (!this.formEmailValid) return

            const cnpjId = this.$store.state.group.group.buyers[0].cnpjId
            const result = await checkUser({ email: this.userInfo.email, cnpjId})
            if (result.data.ok) {
                this.registeredEmail = true
                this.userInfo = {
                    ...this.userInfo,
                    ...result.data.payload,
                }
                this.activeStep++
            } else if (result.status == 401) {
                this.$notify({
                    title: 'Ops! Este usuário já existe nessa empresa/grupo.',
                    message: '',
                    type: 'error',
                    duration: 3000,
                    offset: 100,
                    showClose: false,
                    customClass: 'error'
                })
                this.registredUserInCompany = true
                this.validateEmailForm()
            } else {
                this.registeredEmail = false
                this.activeStep++
            }
        },
        async inviteRegistredUser() {
            const { id: userId } = this.userInfo
            const result = await insertUserCompany({
                userId,
                groupId: this.$route.params.groupId,
                userAllowedProfiles: !this.isOrderAntecipationModeOwn ? '2' : this.calculateUserProfile()
            })
            if (result.ok) {
                this.$notify({
                    title: 'Convite enviado com sucesso.',
                    message: '',
                    type: 'success',
                    duration: 3000,
                    offset: 100,
                    showClose: false
                });
                this.$router.push(`/user/group/${this.$route.params.groupId}`)
            } else {
                this.$notify({
                    title: 'Opa! Encontramos algum erro.',
                    message: '',
                    type: 'error',
                    duration: 3000,
                    offset: 100,
                    showClose: false,
                    customClass: 'error'
                })
            }
        },
        async inviteUser() {
            const { email, name, cpf, phoneNumber } = this.userInfo
            const result = await insertUserCompany({ name, email, cpf: removeMask(cpf), phoneNumber: removeMask(phoneNumber) })
            if (result.ok) {
                this.userInfo = {
                    ...this.userInfo,
                    id: result.payload.id
                }
                if (!this.isOrderAntecipationModeOwn) {
                    await this.inviteRegistredUser()
                } else {
                    this.activeStep++
                }
            } else {
                this.registeredCpf = this.userInfo.cpf
                this.validateUserForm()
            }
        }
    },
    mounted() {
        getEconomicGroupRules(this.$route.params.groupId).then((economicGroupRules) => {
            this.isOrderAntecipationModeOwn = economicGroupRules.data.payload.orderAntecipationMode == 'own'
        })
    }
}
</script>

<style lang="scss" scoped>

</style>
